import { GetStaticProps } from 'next'

import workCopy from '@/data/fixed-pages/copy-work'

import PageWork, { PageWorkProps } from '@/components/PageWork/PageWork'

export const getStaticProps: GetStaticProps<PageWorkProps> = async () => {
  return {
    props: {
      head: { title: 'Work' },
      content: workCopy
    }
  }
}

export default PageWork
